export default __webpack_public_path__ + "images/facebook-icon_c693066f814587392e311cb59c4fc6b9.svg";